<template>
  <Toast/>
  <div class="row">
    <div class="col titre">
      <h2>Véhicule</h2>
    </div>
  </div>
  <CriteresRechercheVehicules @rechercher="rechercher" :marqueLibelles="marqueLibelles" @fermer="fermer"/>
  <ResultatRechercheVehicules :listeMarqueModeleFiltrer="listeMarqueModeleFiltrer" :marqueLibelles="marqueLibelles"
                              :isRechercheDataLoading="isRechercheDataLoading"
                              @removeModeleFromList="removeModeleFromList"/>
</template>

<script>
import CriteresRechercheVehicules
  from '../../../../components/pilotage/Fichiers/Vehicule/CriteresRechercheVehicules.vue'
import ResultatRechercheVehicules
  from '../../../../components/pilotage/Fichiers/Vehicule/ResultatRechercheVehicules.vue'

import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  components: {
    CriteresRechercheVehicules,
    ResultatRechercheVehicules
  },
  mounted() {
    this.$root.$refs.breadcrumbComp.ajout("Recherche Véhicule");
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store
        .dispatch('pilotage/obtenirMarquesAction')
        .then((res) => {
          res.data.forEach((currentMarque) => {
            this.marqueLibelles.push({
              valeur: currentMarque.cle,
              texte: currentMarque.texte
            })
          });
          this.marqueLibelles.sort(this.$commun.compareLibelles);
        });
    this.$store
        .dispatch('pilotage/obtenirModelesAction')
        .then((res) => {
          res.data.forEach((currentModele) => {
            this.listeMarqueModele.push({
              cleModele: currentModele.cle,
              cleMarque: currentModele.cleMarque,
              texteModele: currentModele.texte
            })
          });
          this.listeMarqueModeleFiltrer = this.listeMarqueModele;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      isRechercheDataLoading: false,
      marqueLibelles: [],
      listeMarqueModele: [],
      listeMarqueModeleFiltrer: [],
    }
  },
  methods: {
    rechercher(marque) {

      this.isRechercheDataLoading = true;
      if (marque !== null && marque !== undefined) {
        this.listeMarqueModeleFiltrer = this.listeMarqueModele.filter((p) => p.cleMarque === marque);
      } else {
        this.listeMarqueModeleFiltrer = this.listeMarqueModele;
      }
      this.isRechercheDataLoading = false;
    },
    removeModeleFromList(cle) {
      this.listeMarqueModele = this.listeMarqueModele.filter(current => (current.cleModele != cle))
      this.listeMarqueModeleFiltrer = this.listeMarqueModeleFiltrer.filter(current => (current.cleModele != cle))
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
